import classNames from 'classnames';
import styles from '../styles.module.scss';
import SocialContainer from '../socialButtons/socialContainer';
import {Messages} from 'services/lang/messages';

function hasValueInObject(object = {}, value) {
  return Object.values(object).includes(value);
}

/**
 * @param activeContainer - show is it form or additional container
 * @param registrationType {Object}
 * @param socialsLinks {Array} - social links according to auth type (registration or authorisation)
 * @param fields {Array} form fields(inputs)
 * @param showLinks {function} return {array of links}
 * @param showButtons  {function} return {array of buttons}
 * @param classContainer {String}
 * @param classContainerActive {String}
 * @param additionalClasses {String}
 * @param submitFunction {function}
 * @returns {*}
 * @constructor
 */
const FormComponent = ({
  activeContainer,
  registrationType,
  socialsLinks,
  fields,
  showLinks,
  showButtons,
  classContainer,
  classContainerActive,
  additionalClasses,
}) => {
  return (
    <div className={classNames(styles.formContainer, classContainer, classContainerActive)}>
      <form
        action='#'
        onSubmit={event => event.preventDefault()}
        className={classNames(styles.loginForm, `${additionalClasses ? additionalClasses : ''}`)}
      >
        <h1 className={styles.headingText}>{activeContainer.title}</h1>
        <SocialContainer
          showContainer={hasValueInObject(registrationType, true)}
          containerClass={styles.socialContainer}
          additionalText={Messages.AdditionalText.UseYourAccount}
          additionalTextClass={styles.thirdPartText}
        >
          {socialsLinks}
        </SocialContainer>
        {fields}
        {showLinks(activeContainer)}
        {showButtons(activeContainer)}
      </form>
    </div>
  );
};

export default FormComponent;
